import React, { Component } from 'react';
import { Link, Redirect } from 'react-router-dom';
import { connect } from 'react-redux';

class Product extends Component {
  componentDidMount() {
    // this.props.getIndividualProduct();
  }

  render() {
    if (!localStorage.getItem('city')) return <Redirect to="/" />;

    return (
      <div>
        <div className="page-top-info">
          <div className="container">
            <h4>Category PAge</h4>
            <div className="site-pagination">
              <Link to="/">Home</Link>&nbsp;&nbsp;&nbsp;
              <Link to="/categories">Shop</Link>
            </div>
          </div>
        </div>
        <section className="product-section">
          <div className="container">
            <div className="back-link">
              <Link to="/"> &lt;&lt; Back to Category</Link>
            </div>
            <div className="row">
              <div className="col-lg-6 col-12">
                {/* <div className="product-pic-zoom">
                  <img className="product-big-img" src="img/single-product/1.jpeg" alt="" />
                </div>
                <div className="product-thumbs" tabIndex={1} style={{overflow: 'hidden', outline: 'none'}}>
                  <div className="product-thumbs-track">
                    <div className="pt active" data-imgbigurl="img/single-product/1.jpeg"><img src="img/single-product/1.jpeg" alt="" /></div>
                    <div className="pt" data-imgbigurl="img/single-product/1.jpeg"><img src="img/single-product/1.jpeg" alt="" /></div>
                    <div className="pt" data-imgbigurl="img/single-product/1.jpeg"><img src="img/single-product/1.jpeg" alt="" /></div>
                    <div className="pt" data-imgbigurl="img/single-product/1.jpeg"><img src="img/single-product/1.jpeg" alt="" /></div>
                  </div>
                </div> */}

                <div
                  id="carouselExampleIndicators"
                  className="carousel slide "
                  data-ride="carousel"
                >
                  <div
                    className="carousel-indicators "
                    id="carousel-indicators"
                  >
                    <img
                      data-target="#carouselExampleIndicators"
                      data-slide-to="0"
                      src="img/single-product/1.jpeg"
                      alt=""
                      className="active col-4 productCarouselImage"
                    />

                    <img
                      data-target="#carouselExampleIndicators"
                      data-slide-to="1"
                      src="img/single-product/1.jpeg"
                      alt=""
                      className="col-4 productCarouselImage"
                    />

                    <img
                      data-target="#carouselExampleIndicators"
                      data-slide-to="2"
                      src="img/single-product/1.jpeg"
                      alt=""
                      className="col-4 productCarouselImage"
                    />
                  </div>
                  <div className="carousel-inner">
                    <div className="carousel-item pro active">
                      <img
                        src="img/single-product/1.jpeg"
                        className="d-block w-100"
                        alt="..."
                        height="400px"
                      />
                    </div>
                    <div className="carousel-item pro">
                      <img
                        src="img/single-product/1.jpeg"
                        className="d-block w-100"
                        alt="..."
                        height="400px"
                      />
                    </div>
                    <div className="carousel-item pro">
                      <img
                        src="img/single-product/1.jpeg"
                        className="d-block w-100"
                        alt="..."
                        height="400px"
                      />
                    </div>
                  </div>
                  <a
                    className="carousel-control-prev"
                    href="#carouselExampleIndicators"
                    role="button"
                    data-slide="prev"
                  >
                    <span
                      className="carousel-control-prev-icon"
                      aria-hidden="true"
                    ></span>
                    <span className="sr-only">Previous</span>
                  </a>
                  <a
                    className="carousel-control-next"
                    href="#carouselExampleIndicators"
                    role="button"
                    data-slide="next"
                  >
                    <span
                      className="carousel-control-next-icon"
                      aria-hidden="true"
                    ></span>
                    <span className="sr-only">Next</span>
                  </a>
                </div>
              </div>
              <div className="col-lg-6 product-details col-12">
                <h2 className="p-title">White peplum top</h2>
                <h3 className="p-price">$39.90</h3>
                <h4 className="p-stock">
                  Available: <span>In Stock</span>
                </h4>
                <div className="p-rating">
                  <i className="fa fa-star-o" />
                  <i className="fa fa-star-o" />
                  <i className="fa fa-star-o" />
                  <i className="fa fa-star-o" />
                  <i className="fa fa-star-o fa-fade" />
                </div>
                <div className="p-review">3 reviews Add your review</div>
                <div className="fw-size-choose">
                  <p>Size</p>
                  <div className="sc-item">
                    <input type="radio" name="sc" id="xs-size" />
                    <label htmlFor="xs-size">32</label>
                  </div>
                  <div className="sc-item">
                    <input type="radio" name="sc" id="s-size" />
                    <label htmlFor="s-size">34</label>
                  </div>
                  <div className="sc-item">
                    <input type="radio" name="sc" id="m-size" defaultChecked />
                    <label htmlFor="m-size">36</label>
                  </div>
                  <div className="sc-item">
                    <input type="radio" name="sc" id="l-size" />
                    <label htmlFor="l-size">38</label>
                  </div>
                  <div className="sc-item disable">
                    <input type="radio" name="sc" id="xl-size" disabled />
                    <label htmlFor="xl-size">40</label>
                  </div>
                  <div className="sc-item">
                    <input type="radio" name="sc" id="xxl-size" />
                    <label htmlFor="xxl-size">42</label>
                  </div>
                </div>
                <div className="quantity">
                  <p>Quantity</p>
                  <div className="pro-qty">
                    <input type="text" defaultValue={1} />
                  </div>
                </div>
                <Link to="/cart" className="site-btn">
                  SHOP NOW
                </Link>

                <div id="accordion" className="accordion-area">
                  <div className="panel">
                    <div className="panel-header" id="headingOne">
                      <button
                        className="panel-link active btnMy"
                        data-toggle="collapse"
                        data-target="#collapse1"
                        aria-expanded="true"
                        aria-controls="collapse1"
                        style={{ outline: 'none' }}
                      >
                        information
                      </button>
                    </div>
                    <div
                      id="collapse1"
                      className="collapse show"
                      aria-labelledby="headingOne"
                      data-parent="#accordion"
                    >
                      <div className="panel-body">
                        <p>
                          Lorem ipsum dolor sit amet, consectetur adipiscing
                          elit. Proin pharetra tempor so dales. Phasellus
                          sagittis auctor gravida. Integer bibendum sodales arcu
                          id te mpus. Ut consectetur lacus leo, non scelerisque
                          nulla euismod nec.
                        </p>
                        <p>
                          Approx length 66cm/26" (Based on a UK size 8 sample)
                        </p>
                        <p>Mixed fibres</p>
                        <p>
                          The Model wears a UK size 8/ EU size 36/ US size 4 and
                          her height is 5'8"
                        </p>
                      </div>
                    </div>
                  </div>
                  <div className="panel">
                    <div className="panel-header" id="headingTwo">
                      <button
                        className="panel-link btnMy"
                        data-toggle="collapse"
                        data-target="#collapse2"
                        aria-expanded="false"
                        aria-controls="collapse2"
                        style={{ outline: 'none' }}
                      >
                        care details{' '}
                      </button>
                    </div>
                    <div
                      id="collapse2"
                      className="collapse"
                      aria-labelledby="headingTwo"
                      data-parent="#accordion"
                    >
                      <div className="panel-body">
                        <img src="./img/cards.png" alt="" />
                        <p>
                          Lorem ipsum dolor sit amet, consectetur adipiscing
                          elit. Proin pharetra tempor so dales. Phasellus
                          sagittis auctor gravida. Integer bibendum sodales arcu
                          id te mpus. Ut consectetur lacus leo, non scelerisque
                          nulla euismod nec.
                        </p>
                      </div>
                    </div>
                  </div>
                  <div className="panel">
                    <div className="panel-header" id="headingThree">
                      <button
                        className="panel-link btnMy"
                        data-toggle="collapse"
                        data-target="#collapse3"
                        aria-expanded="false"
                        aria-controls="collapse3"
                        style={{ outline: 'none' }}
                      >
                        shipping &amp; Returns
                      </button>
                    </div>
                    <div
                      id="collapse3"
                      className="collapse"
                      aria-labelledby="headingThree"
                      data-parent="#accordion"
                    >
                      <div className="panel-body">
                        <h4>7 Days Returns</h4>
                        <p>
                          Cash on Delivery Available
                          <br />
                          Home Delivery <span>3 - 4 days</span>
                        </p>
                        <p>
                          Lorem ipsum dolor sit amet, consectetur adipiscing
                          elit. Proin pharetra tempor so dales. Phasellus
                          sagittis auctor gravida. Integer bibendum sodales arcu
                          id te mpus. Ut consectetur lacus leo, non scelerisque
                          nulla euismod nec.
                        </p>
                      </div>
                    </div>
                  </div>
                </div>
                <div className="social-sharing">
                  <a href="www.google.com">
                    <i className="fa fa-google-plus" />
                  </a>
                  <a href="www.pinterest.com">
                    <i className="fa fa-pinterest" />
                  </a>
                  <a href="www.facebook.com">
                    <i className="fa fa-facebook" />
                  </a>
                  <a href="www.twitter.com">
                    <i className="fa fa-twitter" />
                  </a>
                  <a href="www.youtube.com">
                    <i className="fa fa-youtube" />
                  </a>
                </div>
              </div>
            </div>
          </div>
        </section>
      </div>
    );
  }
}

const mapDispatchToProps = (dispatch) => ({
  // getIndividualProduct:()=>dispatch(getIndividualProduct())
});

export default connect(null, mapDispatchToProps)(Product);
